import { Box } from "@mui/material";
import React from "react";
import { ResponsiveBar } from "@nivo/bar";
import { useEffect } from "react";
import { useState } from "react";

export default function ChartTotal({ data }) {
  const [convertData, setConvertData] = useState([]);
  let last = [];
  useEffect(() => {
    if (data && data.length > 0) {
      const tsData = data.filter((item) => item.inoutFlag === "T");
      const inData = data.filter((item) => item.inoutFlag === "I");
      const outData = data.filter((item) => item.inoutFlag === "E");
      const tsWeight = tsData.reduce((sum, item) => sum + item.weight, 0);
      const inWeight = inData.reduce((sum, item) => sum + item.weight, 0);
      const outWeight = outData.reduce((sum, item) => sum + item.weight, 0);

      const tsWeight2 = tsWeight.toFixed(0);
      const inWeight2 = inWeight.toFixed(0);
      const outWeight2 = outWeight.toFixed(0);
      const bupWeight2 = data[0].bupWeight.toFixed(0);
      last = [
        {
          country: "환적",
          TOTAL: tsWeight2,
          TOTALColor: "hsl(278, 70%, 50%)",
        },
        {
          country: "수입",
          TOTAL: inWeight2,
          TOTALColor: "hsl(96, 70%, 50%)",
        },
        {
          country: "수출",
          TOTAL: outWeight2,
          TOTALColor: "hsl(19, 70%, 50%)",
        },
        {
          country: "BUP",
          TOTAL: bupWeight2,
          TOTALColor: "hsl(19, 70%, 50%)",
        },
      ];

      setConvertData(last);
    }
  }, []);
  // const data = [
  //   {
  //     country: "환적",
  //     TOTAL: 184,
  //     TOTALColor: "hsl(278, 70%, 50%)",
  //   },
  //   {
  //     country: "수입",
  //     TOTAL: 300,
  //     TOTALColor: "hsl(96, 70%, 50%)",
  //   },
  //   {
  //     country: "수출",
  //     TOTAL: 106,
  //     TOTALColor: "hsl(19, 70%, 50%)",
  //   },
  // ];
  return (
    <ResponsiveBar
      data={convertData}
      keys={["TOTAL"]}
      indexBy="country"
      margin={{ top: 50, right: 130, bottom: 50, left: 60 }}
      padding={0.3}
      layout="horizontal"
      valueScale={{ type: "linear" }}
      indexScale={{ type: "band", round: true }}
      colors={"#aa5377"}
      borderColor={{
        from: "color",
        modifiers: [["darker", 1.6]],
      }}
      axisTop={null}
      axisRight={null}
      axisBottom={null}
      axisLeft={{
        tickSize: 1,
        tickPadding: 5,
        tickRotation: 0,
        legend: "",
        legendPosition: "middle",
        legendOffset: -40,
      }}
      enableGridX={true}
      enableGridY={false}
      labelSkipWidth={12}
      labelSkipHeight={12}
      labelTextColor={{
        from: "color",
        modifiers: [["darker", 9.6]],
      }}
      legends={[
        {
          dataFrom: "keys",
          anchor: "bottom-right",
          direction: "column",
          justify: false,
          translateX: 120,
          translateY: 0,
          itemsSpacing: 2,
          itemWidth: 100,
          itemHeight: 20,
          itemDirection: "left-to-right",
          itemOpacity: 0.85,
          symbolSize: 20,
          effects: [
            {
              on: "hover",
              style: {
                itemOpacity: 1,
              },
            },
          ],
        },
      ]}
      role="application"
      ariaLabel="Nivo bar chart demo"
      barAriaLabel={(e) =>
        e.id + ": " + e.formattedValue + " in country: " + e.indexValue
      }
    />
  );
}
